import { QUESTIONS } from '../data/questions';

export const MATURITY_LEVELS = [
  { score: 1, label: 'Not started',  color: '#EF4444' },
  { score: 2, label: 'Planning',     color: '#F97316' },
  { score: 3, label: 'In progress',  color: '#EAB308' },
  { score: 4, label: 'Implemented',  color: '#22C55E' },
  { score: 5, label: 'Optimised',    color: '#6366F1' },
];

export function getMaturity(score) {
  if (!score) return { score: 0, label: 'Not assessed', color: '#9CA3AF' };
  return MATURITY_LEVELS.find((m) => m.score === Math.round(score)) || MATURITY_LEVELS[0];
}

/**
 * Average score for a dimension given the assessment records for a client.
 * Returns null if no questions have been scored.
 */
export function getDimensionScore(assessments, dimNum) {
  const qs = QUESTIONS[dimNum];
  if (!qs) return null;
  const dimAssessments = assessments.filter(
    (a) => a.dimension === dimNum && a.score != null
  );
  if (dimAssessments.length === 0) return null;
  const total = dimAssessments.reduce((sum, a) => sum + a.score, 0);
  return total / dimAssessments.length;
}

/**
 * Overall score across all 4 dimensions.
 * Returns null if no dimension has a score.
 */
export function getOverallScore(assessments) {
  const scores = [1, 2, 3, 4]
    .map((d) => getDimensionScore(assessments, d))
    .filter((s) => s !== null);
  if (scores.length === 0) return null;
  return scores.reduce((sum, s) => sum + s, 0) / scores.length;
}

export function formatScore(score) {
  if (score === null || score === undefined) return '—';
  return score.toFixed(1);
}
